import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-static-contact',
  templateUrl: './static-contact.component.html',
  styleUrls: ['./static-contact.component.css']
})
export class StaticContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/static-contact/static-contact.component.ts